// extracted by mini-css-extract-plugin
export default {"accountHeader":"br-z","newDesignAccountHeader":"cr-z","primeBadge":"dr-z","logout":"er-z"};